import React, { useEffect, useState } from 'react';
import withRouter from '../../components/Common/withRouter';
import Spinners from '../../components/Common/Spinner';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import VerticalLayout from '../../components/VerticalLayout';
import PlanCustomizer from './components/planCustomizer';
import Billing from './components/billing/index';
import SubscriptionPlans from './components/subscriptionPlans';
import Feature from './components/featureCategory';
import SquarePlanCreation from './components/squarePlanCreation';
import { useAuthStore } from '../../zustand-store/auth.store';
import { ROLES } from '../../constants/layout';
import PlanUpgrade from './components/planUpgrade';
const BusinessAccess = () => {
  const [selectedTab, setSelectedTab] = useState(null);
  const { role, currentPlan } = useAuthStore((state) => state);
  const [isLoading, setLoading] = useState(true);
  // Define tabs conditionally based on role
  const tabs =
    role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN
      ? [{ id: 4, text: 'Square Plan' }]
      : role === ROLES.BUSINESS_ADMIN
        ? [{ id: 1, text: 'Billing' }]
        : [
            { id: 1, text: 'Billing' },

            { id: 4, text: 'Square Plan' }
          ];

  useEffect(() => {
    if (role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN) {
      setSelectedTab(4);
    } else if (role === ROLES.BUSINESS_ADMIN) {
      if (currentPlan === 'Starter') {
        setSelectedTab(5);
      } else {
        setSelectedTab(1);
      }
    }
    localStorage.setItem('path', '/businessAccess');
  }, []);

  return (
    <VerticalLayout>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="Business Plan" breadcrumbItem="Business Plan" /> */}
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            {/* Left side */}

            <p style={{ fontSize: '16px', fontWeight: 500, color: '#000', margin: 0 }}>
              {role === ROLES.SUPER_ADMIN || role === ROLES.PLATFORM_ADMIN ? 'Plans' : 'Billing'}
            </p>

            {/* Right side */}
            <div className="d-flex align-items-center gap-3"></div>
          </div>
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Row>
              <Col lg="12">
                <Card className="m-0 p-0" style={{ background: selectedTab == 5 && '#F2F2F2' }}>
                  <CardBody>
                    {/* <div >
                      <p className='text-dark' style={{ fontWeight: '600', fontSize: '15px' }}>
                        Business Plan
                      </p>
                    </div> */}

                    <div className="mt-4">
                      {selectedTab === 0 && <PlanCustomizer />}
                      {selectedTab === 1 && <Billing />}
                      {selectedTab === 2 && <SubscriptionPlans />}
                      {selectedTab === 3 && <Feature />}
                      {selectedTab === 4 && <SquarePlanCreation />}
                      {selectedTab === 5 && <PlanUpgrade />}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </VerticalLayout>
  );
};

export default withRouter(BusinessAccess);
